import { EndPoints } from '../EndPoints';
import {
    WarehouseOrderItemDataForm,
    WarehouseOrderItemFilters,
} from '../../models/WarehouseOrderItem';
import useFetch from '../../../hooks/useFetch';
import { useState } from 'react';
import { ServiceEvents } from '../shared/interfaces';

const useWarehouseOrderItemService = () => {
    const { doGet, doPost, doPut, doDelete } = useFetch();

    const [
        fetchingGetWarehouseOrderItemsByOrder,
        setFetchingGetWarehouseOrderItemsByOrder
    ] = useState(false);
    const [fetchingStoreWarehouseOrderItem, setFetchingStoreWarehouseOrderItem] =
        useState(false);
    const [fetchingEditWarehouseOrderItem, setFetchingEditWarehouseOrderItem] =
        useState(false);
    const [fetchingUpdateWarehouseOrderItem, setFetchingUpdateWarehouseOrderItem] =
        useState(false);
    const [fetchingDeleteWarehouseOrderItem, setFetchingDeleteWarehouseOrderItem] =
        useState(false);
    const [fetchingCreateWarehouseOrderItem, setFetchingCreateWarehouseOrderItem] =
        useState(false);
    const [fetchingShowWarehouseOrderItem, setFetchingShowWarehouseOrderItem] =
        useState(false);
    const [fetchingSplitWarehouseOrderItem, setFetchingSplitWarehouseOrderItem] =
        useState(false);
    const [
        fetchingChangeStatusWarehouseOrderItem,
        setFetchingChangeStatusWarehouseOrderItem
    ] = useState(false);
    const [
        fetchingChangeToPreparationStatusWarehouseOrderItem,
        setFetchingChangeToPreparationStatusWarehouseOrderItem
    ] = useState(false);
    const [
        fetchingChangeToDispatchStatusWarehouseOrderItem,
        setFetchingChangeToDispatchStatusWarehouseOrderItem
    ] = useState(false);
    const [
        fetchingChangeToFinishStatusWarehouseOrderItem,
        setFetchingChangeToFinishStatusWarehouseOrderItem
    ] = useState(false);
    const [
        fetchingChangeToAnnulledStatusWarehouseOrderItem,
        setFetchingChangeToAnnulledStatusWarehouseOrderItem
    ] = useState(false);
    const [fetchingGetRatesWarehouseOrderItem, setFetchingGetRatesWarehouseOrderItem] =
        useState(false);
    const [
        fetchingUpdateRatesWarehouseOrderItem,
        setFetchingUpdateRatesWarehouseOrderItem
    ] = useState(false);

    const [
        fetchingHasAllFinishedWarehouseOrderItems,
        setFetchingHasAllFinishedWarehouseOrderItems
    ] = useState(false);

    const [fetchingShowStorageDataWareHouseOrderItem, SetFetchingShowStorageDataWareHouseOrderItem] = useState(false);

    const getAllWarehouseOrderItemsByOrder = (
        transportationOrderFilters: WarehouseOrderItemFilters,
        transportationOrderId: number,
        events: ServiceEvents = {}
    ) => {
        const queryString = Object.entries(transportationOrderFilters)
            .map(([key, value]) => `${key}=${value}`)
            .join('&');
        const url = `${EndPoints.WAREHOUSE_ORDERS.GET_WAREHOUSE_ORDER_ITEMS_BY_ORDER}?${queryString}`;
        doGet({
            ...events,
            url: url.replace(':id', transportationOrderId.toString()),
            setFetching: setFetchingGetWarehouseOrderItemsByOrder
        });
    };

    const getAllWarehouseOrderItemsByUnifiedOrder = (
        filters: WarehouseOrderItemFilters,
        orderId: number,
        events: ServiceEvents = {}
    ) => {
        const queryString = Object.entries(filters)
            .map(([key, value]) => `${key}=${value}`)
            .join('&');
        const url = `${EndPoints.WAREHOUSE_ORDERS.GET_WAREHOUSE_ORDER_ITEMS_BY_UNIFIED_ORDER}?${queryString}`;
        doGet({
            ...events,
            url: url.replace(':order_id', orderId.toString()),
            setFetching: setFetchingGetWarehouseOrderItemsByOrder
        });
    };

    const createWarehouseOrderItem = (id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.WAREHOUSE_ORDERS.CREATE_WAREHOUSE_ORDER_ITEM.replace(
                ':id',
                id.toString()
            ),
            setFetching: setFetchingCreateWarehouseOrderItem
        });
    };

    const storeWarehouseOrderItem = (
        transportationOrderItemDataForm: WarehouseOrderItemDataForm,
        events: ServiceEvents = {}
    ) => {
        doPost({
            ...events,
            url: EndPoints.WAREHOUSE_ORDERS.STORE_WAREHOUSE_ORDER_ITEM,
            body: transportationOrderItemDataForm,
            setFetching: setFetchingStoreWarehouseOrderItem
        });
    };

    const editWarehouseOrderItem = (id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.WAREHOUSE_ORDERS.EDIT_WAREHOUSE_ORDER_ITEM.replace(
                ':id',
                id.toString()
            ),
            setFetching: setFetchingEditWarehouseOrderItem
        });
    };

    const showWarehouseOrderItem = (id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.WAREHOUSE_ORDERS.SHOW_WAREHOUSE_ORDER_ITEM.replace(
                ':id',
                id.toString()
            ),
            setFetching: setFetchingShowWarehouseOrderItem
        });
    };

    const updateWarehouseOrderItem = (
        id: number,
        transportationOrderItemDataForm: WarehouseOrderItemDataForm,
        events: ServiceEvents = {}
    ) => {
        doPut({
            ...events,
            url: EndPoints.WAREHOUSE_ORDERS.UPDATE_WAREHOUSE_ORDER_ITEM.replace(
                ':id',
                id.toString()
            ),
            body: transportationOrderItemDataForm,
            setFetching: setFetchingUpdateWarehouseOrderItem
        });
    };

    const deleteWarehouseOrderItem = (id: number, events: ServiceEvents = {}) => {
        doDelete({
            ...events,
            url: EndPoints.WAREHOUSE_ORDERS.DELETE_WAREHOUSE_ORDER_ITEM.replace(
                ':id',
                id.toString()
            ),
            setFetching: setFetchingDeleteWarehouseOrderItem
        });
    };

    const changeStatusWarehouseOrderItem = (
        id: number,
        status: string,
        events: ServiceEvents = {}
    ) => {
        doPut({
            ...events,
            url: EndPoints.WAREHOUSE_ORDERS.CHANGE_STATUS_WAREHOUSE_ORDER_ITEM.replace(
                ':id',
                id.toString()
            ),
            body: { status: status },
            setFetching: setFetchingChangeStatusWarehouseOrderItem
        });
    };

    const changeToDispatchStatusWarehouseOrderItem = (
        id: number,
        status: string,
        events: ServiceEvents = {}
    ) => {
        doPut({
            ...events,
            url: EndPoints.WAREHOUSE_ORDERS.CHANGE_TO_DISPATCH_STATUS_WAREHOUSE_ORDER_ITEM.replace(
                ':id',
                id.toString()
            ),
            body: { status: status },
            setFetching: setFetchingChangeToDispatchStatusWarehouseOrderItem
        });
    };

    const changeToPreparationStatusWarehouseOrderItem = (
        id: number,
        status: string,
        events: ServiceEvents = {}
    ) => {
        doPut({
            ...events,
            url: EndPoints.WAREHOUSE_ORDERS.CHANGE_TO_PREPARATION_STATUS_WAREHOUSE_ORDER_ITEM.replace(
                ':id',
                id.toString()
            ),
            body: { status: status },
            setFetching: setFetchingChangeToPreparationStatusWarehouseOrderItem
        });
    };

    const changeToFinishStatusWarehouseOrderItem = (
        id: number,
        status: string,
        events: ServiceEvents = {}
    ) => {
        doPut({
            ...events,
            url: EndPoints.WAREHOUSE_ORDERS.CHANGE_TO_FINISH_STATUS_WAREHOUSE_ORDER_ITEM.replace(
                ':id',
                id.toString()
            ),
            body: { status: status },
            setFetching: setFetchingChangeToFinishStatusWarehouseOrderItem
        });
    };

    const changeToAnnulledStatusWarehouseOrderItem = (
        id: number,
        status: string,
        events: ServiceEvents = {}
    ) => {
        doPut({
            ...events,
            url: EndPoints.WAREHOUSE_ORDERS.CHANGE_TO_ANNULLED_STATUS_WAREHOUSE_ORDER_ITEM.replace(
                ':id',
                id.toString()
            ),
            body: { status: status },
            setFetching: setFetchingChangeToAnnulledStatusWarehouseOrderItem
        });
    };



    const HasAllFinishedWarehouseOrderItems = (
        id: number,
        status: string,
        events: ServiceEvents = {}
    ) => {
        doGet({
            ...events,
            url: EndPoints.WAREHOUSE_ORDERS.HAS_ALL_FINISHED_WAREHOUSE_ORDER_ITEMS.replace(
                ':id',
                id.toString()
            ).replace(':status_detail_toi', status.toString()),
            setFetching: setFetchingHasAllFinishedWarehouseOrderItems
        });
    };

    const showStorageDataToWareHouseOrderDetail = (
        quote_id: number,
        depot_id: number,
        product_id: number,
        events: ServiceEvents = {}
        ) => {
        doGet({
            ...events,
            url: EndPoints.WAREHOUSE_ORDERS.GET_WAREHOUSE_ORDER_DETAILS_BY_REQUEST
            .replace(':warehouse_order_id', quote_id.toString())
            .replace(':depot_id', depot_id.toString())
            .replace(':product_id', product_id.toString()),
            setFetching: SetFetchingShowStorageDataWareHouseOrderItem,
        });

    };

    return {
        getAllWarehouseOrderItemsByOrder,
        getAllWarehouseOrderItemsByUnifiedOrder,
        createWarehouseOrderItem,
        storeWarehouseOrderItem,
        showWarehouseOrderItem,
        editWarehouseOrderItem,
        updateWarehouseOrderItem,
        deleteWarehouseOrderItem,
        changeStatusWarehouseOrderItem,
        HasAllFinishedWarehouseOrderItems,
        changeToPreparationStatusWarehouseOrderItem,
        changeToDispatchStatusWarehouseOrderItem,
        changeToFinishStatusWarehouseOrderItem,
        changeToAnnulledStatusWarehouseOrderItem,
        showStorageDataToWareHouseOrderDetail,
        fetchingChangeStatusWarehouseOrderItem,
        fetchingShowWarehouseOrderItem,
        fetchingGetWarehouseOrderItemsByOrder,
        fetchingStoreWarehouseOrderItem,
        fetchingEditWarehouseOrderItem,
        fetchingUpdateWarehouseOrderItem,
        fetchingDeleteWarehouseOrderItem,
        fetchingCreateWarehouseOrderItem,
        fetchingSplitWarehouseOrderItem,
        fetchingGetRatesWarehouseOrderItem,
        fetchingUpdateRatesWarehouseOrderItem,
        fetchingHasAllFinishedWarehouseOrderItems,
        fetchingChangeToPreparationStatusWarehouseOrderItem,
        fetchingChangeToDispatchStatusWarehouseOrderItem,
        fetchingChangeToFinishStatusWarehouseOrderItem,
        fetchingChangeToAnnulledStatusWarehouseOrderItem,
        fetchingShowStorageDataWareHouseOrderItem
    };
};

export default useWarehouseOrderItemService;
